(() => {
  const carouselSelector = '[data-ag-home-carousel]';

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initCarousel = (root) => {
    if (root.dataset.agHomeReady === 'true') return;

    const track = root.querySelector('[data-ag-home-track]');
    const slides = Array.from(root.querySelectorAll('[data-ag-home-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ag-home-dot]'));
    const previous = root.querySelector('[data-ag-home-previous]');
    const next = root.querySelector('[data-ag-home-next]');

    if (!track || slides.length === 0) return;

    root.dataset.agHomeReady = 'true';

    let activeIndex = 0;
    let scrollFrame;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', String(dotIndex === activeIndex));
      });
    };

    const nearestSlideIndex = () => {
      const scrollPosition = track.scrollLeft;
      return slides.reduce((closestIndex, slide, index) => {
        const closestDistance = Math.abs(slides[closestIndex].offsetLeft - scrollPosition);
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        return distance < closestDistance ? index : closestIndex;
      }, 0);
    };

    const scrollToIndex = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slides[targetIndex].offsetLeft,
        behavior: reducedMotion() ? 'auto' : 'smooth',
      });
      setActive(targetIndex);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => scrollToIndex(Number(dot.dataset.agHomeIndex)));
    });

    previous?.addEventListener('click', () => scrollToIndex(activeIndex - 1));
    next?.addEventListener('click', () => scrollToIndex(activeIndex + 1));

    track.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => setActive(nearestSlideIndex()));
      },
      { passive: true }
    );

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToIndex(activeIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToIndex(activeIndex + 1);
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(carouselSelector).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
